'use client';

import { forwardRef } from 'react';

import { blockInvalidChar } from '@/utils/helper';
import TextField, { FormPropTypes } from './TextField';
import Button from '../Button';
import { twJoin } from 'tailwind-merge';

interface PropTypes extends FormPropTypes {
  inputClassName?: string;
  placeholder?: string;
  isValidation?: boolean;
  onChange?: any;
  value?: string;
  defaultValue?: string;
}

const PincodeField = forwardRef<HTMLInputElement, PropTypes>(
  (
    {
      error,
      inputClassName,
      placeholder,
      defaultValue,
      isValidation,
      onChange,
      value = '',
    },
    ref
  ) => {
    return (
      <TextField
        ref={ref}
        isValidation={isValidation}
        onChange={onChange}
        error={error}
        name='pincode'
        id='pincode'
        type='number'
        maxLength={6}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        inputClassName={twJoin(inputClassName, 'pr-16')}
        onKeyDown={blockInvalidChar}
        endAdornment={
          <Button
            disabled={!value}
            type='submit'
            variant='link'
            label='Check'
            className='absolute inset-y-0 right-0 px-3 text-sm'
          />
        }
      />
    );
  }
);

PincodeField.displayName = 'PincodeField';
export default PincodeField;
